import type { SafetyOccurrence } from '@cobliteam/common-types';

import Icon from '@cobliteam/ui/icons';

import Button from '@cobliteam/ui/components/Button';

interface SafetyOccurrenceTitleProps {
  selectedSafetyOccurrences: SafetyOccurrence[];
  size?: 'sm' | 'md';
}

const SafetyOccurrenceTitle = ({ selectedSafetyOccurrences, size }: SafetyOccurrenceTitleProps) => {
  return (
    <Button size={size} variant='text' type='button' startIcon={<Icon name='octagon-alert' />}>
      Ocorrências {selectedSafetyOccurrences.length > 0 ? `(${selectedSafetyOccurrences?.length})` : ''}
    </Button>
  );
};

export default SafetyOccurrenceTitle;
